export const ABERRANT_TYPES = {
  ABERRANT_OLTA_RESERVATION: 'ABERRANT_OLTA_RESERVATION',
  ABERRANT_INELIGIBLE_RATE_CODE: 'ABERRANT_INELIGIBLE_RATE_CODE',
  ABERRANT_PMSEXTRACTOR_CHANNEL_CODE_EXCLUSION: 'ABERRANT_PMSEXTRACTOR_CHANNEL_CODE_EXCLUSION',
  ABERRANT_OVERLAP_SAME_HOTEL: 'ABERRANT_OVERLAP_SAME_HOTEL',
  ABERRANT_OVERLAP_DIFFERENT_HOTEL: 'ABERRANT_OVERLAP_DIFFERENT_HOTEL',
  ABERRANT_HOTEL_ACCOUNT_LOCKED: 'ABERRANT_HOTEL_ACCOUNT_LOCKED',
  ABERRANT_HOTEL_NO_CARD_AT_DECLARATION_DATE: 'ABERRANT_HOTEL_NO_CARD_AT_DECLARATION_DATE',
  UNKNOWN_PMID: 'UNKNOWN_PMID',
  ABERRANT_HOTEL_INVALID_CARD_NUMBER: 'ABERRANT_HOTEL_INVALID_CARD_NUMBER',
  ABERRANT_HOTEL_INVALID_LUHN_KEY: 'ABERRANT_HOTEL_INVALID_LUHN_KEY',
  ABERRANT_UNKNOWN_PLACE: 'ABERRANT_UNKNOWN_PLACE',
  ABERRANT_STAY_DATE_BEFORE_OPENING_DATE: 'ABERRANT_STAY_DATE_BEFORE_OPENING_DATE',
  ABERRANT_NUMBER_OF_NIGHTS_TO_BIG: 'ABERRANT_NUMBER_OF_NIGHTS_TO_BIG',
  ABERRANT_NUMBER_OF_NIGHTS_TO_SMALL: 'ABERRANT_NUMBER_OF_NIGHTS_TO_SMALL',
  ABERRANT_INCONSISTENT_DATES: 'ABERRANT_INCONSISTENT_DATES',
  ABERRANT_INVALID_DATES_ORDER: 'ABERRANT_INVALID_DATES_ORDER',
  ABERRANT_INVALID_CHECKIN_DATE: 'ABERRANT_INVALID_CHECKIN_DATE',
  ABERRANT_INVALID_CHECKOUT_DATE: 'ABERRANT_INVALID_CHECKOUT_DATE',
  ABERRANT_PMSEXTRACTOR_NO_STAY_EXPENSE: 'ABERRANT_PMSEXTRACTOR_NO_STAY_EXPENSE',
  ABERRANT_HOTEL_UNKNOWN_PRICE: 'ABERRANT_HOTEL_UNKNOWN_PRICE',
  ABERRANT_INVALID_PRICE_RANGE: 'ABERRANT_INVALID_PRICE_RANGE',
  ABERRANT_INVALID_PRICE_RANGE_DAY_USE: 'ABERRANT_INVALID_PRICE_RANGE_DAY_USE',
  ABERRANT_BUSINESS_LOCKED_COMPANY: 'ABERRANT_BUSINESS_LOCKED_COMPANY',
  ABERRANT_INELIGIBLE_SEGMENTATION: 'ABERRANT_INELIGIBLE_SEGMENTATION',
  ABERRANT_MULTI_ORDERS: 'ABERRANT_MULTI_ORDERS'
}

export const ABERRANT_MODAL_CONTENTS = {
  [ABERRANT_TYPES.ABERRANT_OLTA_RESERVATION]: {
    title: 'slider.not.eligible.olta.title',
    description: 'slider.not.eligible.olta.description1'
  },
  [ABERRANT_TYPES.ABERRANT_INELIGIBLE_RATE_CODE]: {
    title: 'slider.not.eligible.rate.code.title',
    description: 'slider.not.eligible.rate.code.description'
  },
  [ABERRANT_TYPES.ABERRANT_PMSEXTRACTOR_CHANNEL_CODE_EXCLUSION]: {
    title: 'slider.not.eligible.rate.code.title',
    description: 'slider.not.eligible.rate.code.description'
  },
  [ABERRANT_TYPES.ABERRANT_OVERLAP_SAME_HOTEL]: {
    title: 'slider.overlapHotel.title',
    description: 'slider.overlapHotel.description'
  },
  [ABERRANT_TYPES.ABERRANT_OVERLAP_DIFFERENT_HOTEL]: {
    title: 'slider.overlapHotel.title',
    description: 'slider.overlapHotel.description'
  },
  [ABERRANT_TYPES.ABERRANT_HOTEL_ACCOUNT_LOCKED]: {
    title: 'slider.lockedAccount.title',
    description: 'slider.lockedAccount.description'
  },
  [ABERRANT_TYPES.ABERRANT_HOTEL_NO_CARD_AT_DECLARATION_DATE]: {
    title: 'slider.noPmid.title',
    description: 'slider.defaultAberrant.description'
  },
  [ABERRANT_TYPES.UNKNOWN_PMID]: {
    title: 'slider.noPmid.title',
    description: 'slider.defaultAberrant.description'
  },
  [ABERRANT_TYPES.ABERRANT_HOTEL_INVALID_CARD_NUMBER]: {
    title: 'slider.noPmid.title',
    description: 'slider.defaultAberrant.description'
  },
  [ABERRANT_TYPES.ABERRANT_UNKNOWN_PLACE]: {
    title: 'slider.notParticipatingHotel.title',
    description: 'slider.notParticipatingHotel.description'
  },
  [ABERRANT_TYPES.ABERRANT_STAY_DATE_BEFORE_OPENING_DATE]: {
    title: 'slider.notParticipatingHotel.title',
    description: 'slider.notParticipatingHotel.description'
  },
  [ABERRANT_TYPES.ABERRANT_NUMBER_OF_NIGHTS_TO_BIG]: {
    title: 'slider.defaultAberrant.title',
    description: 'slider.defaultAberrant.description'
  },
  [ABERRANT_TYPES.ABERRANT_NUMBER_OF_NIGHTS_TO_SMALL]: {
    title: 'slider.defaultAberrant.title',
    description: 'slider.defaultAberrant.description'
  },
  [ABERRANT_TYPES.ABERRANT_INCONSISTENT_DATES]: {
    title: 'slider.defaultAberrant.title',
    description: 'slider.defaultAberrant.description'
  },
  [ABERRANT_TYPES.ABERRANT_INVALID_DATES_ORDER]: {
    title: 'slider.defaultAberrant.title',
    description: 'slider.defaultAberrant.description'
  },
  [ABERRANT_TYPES.ABERRANT_INVALID_CHECKIN_DATE]: {
    title: 'slider.defaultAberrant.title',
    description: 'slider.defaultAberrant.description'
  },
  [ABERRANT_TYPES.ABERRANT_INVALID_CHECKOUT_DATE]: {
    title: 'slider.defaultAberrant.title',
    description: 'slider.defaultAberrant.description'
  },
  [ABERRANT_TYPES.ABERRANT_HOTEL_UNKNOWN_PRICE]: {
    title: 'slider.not.eligible.rate.code.title',
    description: 'slider.not.eligible.rate.code.description'
  },
  [ABERRANT_TYPES.ABERRANT_INVALID_PRICE_RANGE]: {
    title: 'slider.not.eligible.rate.code.title',
    description: 'slider.not.eligible.rate.code.description'
  },
  [ABERRANT_TYPES.ABERRANT_INVALID_PRICE_RANGE_DAY_USE]: {
    title: 'slider.not.eligible.rate.code.title',
    description: 'slider.not.eligible.rate.code.description'
  },
  [ABERRANT_TYPES.ABERRANT_BUSINESS_LOCKED_COMPANY]: {
    title: 'slider.defaultAberrant.title',
    description: 'slider.defaultAberrant.description'
  },
  [ABERRANT_TYPES.ABERRANT_INELIGIBLE_SEGMENTATION]: {
    title: 'slider.not.eligible.rate.code.title',
    description: 'slider.not.eligible.rate.code.description'
  }
}
